<script>
export default {
  props: {
    haveData: {},
    dataName: {
      type: String,
      default: ''
    },
    tag: {
      default: 'div',
      type: String
    }
  },
  data() {
    return {
      show: false
    }
  },
  created() {
    const watchid = this.$watch('haveData', () => {
      this.show = true
      watchid()
    })
  },
  render(createElement) {
    if (this.show) {
      // return this.haveData
      //   ? createElement(this.tag, this.$slots.default)
      //   : createElement(
      //       this.tag,
      //       {
      //         style: {
      //           textAlign: 'center'
      //         }
      //       },
      //       [`暂无${this.dataName}数据`]
      //     )
      return createElement(
        this.tag,
        this.haveData
          ? this.$slots.default
          : {
              class: {
                'empty-style': true
              }
            }
      )
    } else {
      return createElement(this.tag)
    }
  }
}
</script>
